module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-26-a36cdca637e210007c633f37e5ef708f.svg";